/* ANIMATION INDEX */

  $("._detal_link._contact").hover(
    function () {
      $("._lemons").addClass('anim');
    }, 
    function () {
      $("._lemons").removeClass('anim');
    }
  );

  $("._detal_link._ourlocations").hover(
    function () {
      $("._rosebushes").addClass('anim');
    }, 
    function () {
      $("._rosebushes").removeClass('anim');
    }
  );

  $("._detal_link._ourlocations").hover(
    function () {
      $("._rosebushes").addClass('anim');
    }, 
    function () {
      $("._rosebushes").removeClass('anim');
    }
  );

  $("._detal_link._merchandise").hover(
    function () {
      $("._bees").addClass('anim');
    }, 
    function () {
      $("._bees").removeClass('anim');
    }
  );

  $("._detal_link._shop").hover(
    function () {
      $("._coconuts").addClass('anim');
    }, 
    function () {
      $("._coconuts").removeClass('anim');
    }
  );

  $("._detal_link._mix").hover(
    function () {
      $("._kids").addClass('anim');
    }, 
    function () {
      $("._kids").removeClass('anim');
    }
  );

  $("._detal_link._cordialquiz").hover(
    function () {
      $("._valves").addClass('anim');
    }, 
    function () {
      $("._valves").removeClass('anim');
    }
  );

  $("._detal_link._whatourfans").hover(
    function () {
      $("._music").addClass('anim');
    }, 
    function () {
      $("._music").removeClass('anim');
    }
  );

  $("._detal_link._createdbox").hover(
    function () {
      $("._bottles").addClass('anim');
    }, 
    function () {
      $("._bottles").removeClass('anim');
    }
  );

/* END ANIMATION INDEX */



  $("._btn_subscribe ._icon").hover(
    function () {
      $(".subs_info").addClass('active');
    }, 
    function () {
      $(".subs_info").removeClass('active');
    }
  );

/* MENU */

  $(document).ready(function() {
    
    $("._menubtn").click(function(){
      $("._sidenav._menu").addClass("active");
      $("._back_menu").addClass("active");
    });

    $("._close_menu").click(function(){
      $(this).removeClass("active");
      $("._sidenav._menu").removeClass("active");
      $("._back_menu").removeClass("active");
    });
    $("._back_menu").click(function(){
      $(this).removeClass("active");
      $("._sidenav._menu").removeClass("active");
    });
    
    $("._morecollection").click(function(){
      $(this).toggleClass("active");
      $("section._shop._2").toggleClass("active");
    });
    
    $("._cart_action").click(function(){
      $("._sidecart").addClass("active");
      $("._back_cart").addClass("active");
    });    
    $("._btn_add_cart").click(function(){
      $("._sidecart").addClass("active");
      $("._back_cart").addClass("active");
    });    
     
    $("._back_cart").click(function(){
      $("._sidecart").removeClass("active");
      $("._back_cart").removeClass("active");
    });
    
    $("._close_cart").click(function(){
      $("._sidecart").removeClass("active");
      $("._back_cart").removeClass("active");
    }); 
    $("._btn_add_basket").click(function(){
      $("._sidecart").addClass("active");
      $("._back_cart").addClass("active");
    });  
    
    $("._images_bundle>.row>._img").click(function(){
      $(this).toggleClass("active");
    });  
    
    
    $("._search_btn").click(function(){
      $("._modal_search").addClass("active");
      $("._back_search").addClass("active");
    });  
    $("._back_search").click(function(){
      $("._modal_search").removeClass("active");
      $("._search_btn").removeClass("active");
    });  
    $("._close_search").click(function(){
      $("._modal_search").removeClass("active");
      $("._search_btn").removeClass("active");
    });  
    
    $("._btn_add_cart").click(function(){
      $(this).toggleClass("added");
    });
    
  });
/* END MENU */


$(document).ready(function() {
  $("#_cordialquiz_btn").click(function(){
    $("._emailcapture._1").addClass("_open");
    $("._back_emailcapture").addClass("active");
  });
  $("._back_emailcapture").click(function(){
    $("._emailcapture._1").removeClass("_open");
    $(this).removeClass("active");
  });
  $("._close_emailcapture").click(function(){
    $("._emailcapture._1").removeClass("_open");
    $("._back_emailcapture").removeClass("active");
  });
  
});


$(document).ready(function() {
  setTimeout(function() {
    $('.wrapper1').addClass('isloaded');
  }, 1000);
  setTimeout(function() {
    $('.wrapper1.isloaded').addClass('loaded');
  }, 3000);
});



jQuery(function(){

  $(window).load(function(){
  
  $('.wrapper1').removeClass('preload');
  
  });

});

/* SCROLL UP AND DOWN */
  var scrollPos = 0;
  // adding scroll event
  window.addEventListener('scroll', function(){
    // detects new state and compares it with the new one
    if ((document.body.getBoundingClientRect()).top > scrollPos)
      $("._header_landing.fixed").addClass("show");
    else
      $("._header_landing.fixed").removeClass("show");
    // saves the new position for iteration.
    scrollPos = (document.body.getBoundingClientRect()).top;
  });
/* END SCROLL UP AND DOWN */

$(document).ready(function() { 
  // initiate ScrollMagic Controller
  let controller = new ScrollMagic.Controller();



  /* HEADER */
  var anim_header = new ScrollMagic.Scene({triggerElement: "#_trigger_header"})
  .setClassToggle("._header_landing", "fixed")
  //.addIndicators()
  .addTo(controller);

  /*
  var anim_about_1 =TweenMax.to("section._about._1>._cont>img._moun._1", 0.5, {y: "-16%", ease: Linear.easeNone});
  var scene_about = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 500})
  .setTween(anim_about_1)
  //.addIndicators()
  .addTo(controller);
  
  var anim_about_2 =TweenMax.to("section._about._1>._cont>img._moun._2", 0.5, {y: "10%", ease: Linear.easeNone});
  var scene_about2 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 500})
  .setTween(anim_about_2)
  //.addIndicators()
  .addTo(controller);

  var anim_about_3 =TweenMax.to("section._about._1>._cont>._info", 0.5, {y: "-20%", ease: Linear.easeNone});
  var scene_about3 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 500})
  .setTween(anim_about_3)
  //.addIndicators()
  .addTo(controller);
  
  var anim_about_4 =TweenMax.to("section._about._1>._cont>img._sky", 0.5, {y: "-5%", ease: Linear.easeNone});
  var scene_about4 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 500})
  .setTween(anim_about_4)
  //.addIndicators()
  .addTo(controller);
  
  var anim_about_6 =TweenMax.to("section._about._2>._cont>img._three", 0.5, {y: "-20%", ease: Linear.easeNone});
  var scene_about6 = new ScrollMagic.Scene({triggerElement: "#trigger_2", duration: 700})
  .setTween(anim_about_6)
  //.addIndicators()
  .addTo(controller);
  
  var anim_about_7 =TweenMax.to("section._about._2>._cont>._info._1", 0.5, {y: "-50%", ease: Linear.easeNone});
  var scene_about7 = new ScrollMagic.Scene({triggerElement: "#trigger_2", duration: 700})
  .setTween(anim_about_7)
  //.addIndicators()
  .addTo(controller);
  
  var anim_about_8 =TweenMax.to("section._about._2>._cont>._info._2", 0.5, {y: "-50%", ease: Linear.easeNone});
  var scene_about8 = new ScrollMagic.Scene({triggerElement: "#trigger_2", duration: 700})
  .setTween(anim_about_8)
  //.addIndicators()
  .addTo(controller);
                  
  
  
  
  var anim_reviews_1 =TweenMax.to("section._reviews._1>._cont>img._sky", 0.5, {y: "-5%", ease: Linear.easeNone});
  var scene_reviews1 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 700})
  .setTween(anim_reviews_1)
  //.addIndicators()
  .addTo(controller);
  
  var anim_reviews_3 =TweenMax.to("section._reviews._1>._cont>img._moun._1", 0.5, {y: "10%", ease: Linear.easeNone});
  var scene_reviews3 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_reviews_3)
  //.addIndicators()
  .addTo(controller);
  
  var anim_reviews_4 =TweenMax.to("section._reviews._2>._cont>img._moun._1", 0.5, {y: "10%", ease: Linear.easeNone});
  var scene_reviews4 = new ScrollMagic.Scene({triggerElement: "#trigger_2", duration: 600})
  .setTween(anim_reviews_4)
  //.addIndicators()
  .addTo(controller);
  
  var anim_reviews_5 =TweenMax.to("section._reviews._2>._cont>img._moun._2", 0.5, {y: "-9%", ease: Linear.easeNone});
  var scene_reviews5 = new ScrollMagic.Scene({triggerElement: "#trigger_2", duration: 600})
  .setTween(anim_reviews_5)
  //.addIndicators()
  .addTo(controller);
  
  var anim_findus_1 =TweenMax.to("section._findus._1>._cont>img._moun._1", 0.5, {y: "-2%", ease: Linear.easeNone});
  var scene_findus_1 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_findus_1)
  //.addIndicators()
  .addTo(controller);
  
  var anim_findus_2 =TweenMax.to("section._findus._1>._cont>img._moun._2", 0.5, {y: "10%", ease: Linear.easeNone});
  var scene_findus_2 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_findus_2)
  //.addIndicators()
  .addTo(controller);
  */
  
  var anim_shop_1 =TweenMax.to("section._shop._1 img._fruits", 0.5, {y: "-50%", ease: Linear.easeNone});
  var scene_shop_1 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_shop_1)
  //.addIndicators()
  .addTo(controller);
  
  var anim_shop_2 =TweenMax.to("section._shop._1 img._img._table1", 0.5, {y: "-10%", ease: Linear.easeNone});
  var scene_shop_2 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_shop_2)
  //.addIndicators()
  .addTo(controller);
  
  var anim_shop_3 =TweenMax.to("section._shop._1 img._img._table2", 0.5, {y: "-10%", ease: Linear.easeNone});
  var scene_shop_3 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_shop_3)
  //.addIndicators()
  .addTo(controller);
  
  var anim_shop_4 =TweenMax.to("section._shop._1 img._img._bottle1", 0.5, {y: "30%", ease: Linear.easeNone});
  var scene_shop_4 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_shop_4)
  //.addIndicators()
  .addTo(controller);
  
  var anim_shop_5 =TweenMax.to("section._shop._1 img._img._bottle2", 0.5, {y: "25%", ease: Linear.easeNone});
  var scene_shop_5 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_shop_5)
  //.addIndicators()
  .addTo(controller);
  
  var anim_contact_1 =TweenMax.to("section._contact._1>._cont ._in>._mountain._1", 0.5, {y: "15%", ease: Linear.easeNone});
  var scene_contact_1 = new ScrollMagic.Scene({triggerElement: "#trigger_1", duration: 600})
  .setTween(anim_contact_1)
  //.addIndicators()
  .addTo(controller);
  
});



$(document).ready(function() {
  setTimeout(function() {
    $("._fera._2 .fera-testimonialCarousel").removeAttr("data-fera-carousel-size");
    setTimeout(function() {
      $( "._fera._2 .fera-testimonialCarousel" ).attr( "data-fera-carousel-size", "1" );
    }, 1000);
  }, 1000);
});



// Archivo: custom-cart.js

// Función para manipular los botones de aumento y reducción de cantidad
function adjustQuantity(item, increaseBy) {
  // Obtén la etiqueta del producto del objeto item
  var etiqueta = item.propertyArray.find(function(property) {
    return property.name === 'etiqueta';
  });

  // Verifica la etiqueta y ajusta la cantidad según corresponda
  if (etiqueta && etiqueta.value === 'wholesale') {
    // Si la etiqueta es 'wholesale', aumenta o reduce de a 4
    item.setQuantity(item.quantity + (4 * increaseBy)); // Aumenta o reduce de a 4
  } else {
    // Si no tiene la etiqueta 'wholesale', aumenta o reduce de a 1
    item.setQuantity(item.quantity + increaseBy); // Aumenta o reduce de a 1
  }
}

// Escucha el evento click en los botones de aumento y reducción de cantidad
document.addEventListener('click', function(event) {
  var target = event.target;
  var itemIndex = target.getAttribute('rv-data-cart-update');
  var quantityChange = target.getAttribute('rv-data-cart-quantity');

  if (itemIndex && quantityChange) {
    var item = window.rivet.data.cart.items[parseInt(itemIndex) - 1];
    var increaseBy = parseInt(quantityChange);

    if (item && increaseBy) {
      adjustQuantity(item, increaseBy);
    }
  }
});
